import { ChangeDetectorRef, Component, ElementRef, Input, OnDestroy, OnInit } from '@angular/core';
import { CmsBannerComponent } from '@spartacus/core';
import { CarouselComponent, CarouselService } from '@spartacus/storefront';
import { Subscription, interval, of } from 'rxjs';

@Component({
  selector: 'cx-carousel',
  templateUrl: './carousel.component.html',
  styleUrl: './carousel.component.scss',
  standalone: false,
})
export class CustomCarouselComponent extends CarouselComponent implements OnInit, OnDestroy {
  @Input() timeout = 500;
  @Input() _items?: CmsBannerComponent[];

  subscriptionTimer = new Subscription();
  itemsLength = 0;

  constructor(
    el: ElementRef,
    service: CarouselService,
    public changeDetector: ChangeDetectorRef,
  ) {
    super(el, service);
  }

  override ngOnInit(): void {
    super.ngOnInit();

    if (this._items?.length) {
      this.items = this._items.map(item => of(item));
    }

    this.itemsLength = this._items?.length ?? 0;
    this.timeout && this.startAutoSlide();
  }

  ngOnDestroy(): void {
    if (this.subscriptionTimer) {
      this.subscriptionTimer.unsubscribe();
    }
  }

  startAutoSlide() {
    this.subscriptionTimer = interval(this.timeout * 1000).subscribe(() => {
      this.activeSlide = (this.activeSlide + 1) % this.itemsLength;
      this.changeDetector.detectChanges();
    });
  }
}
